import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 500px !important;

  *::-webkit-scrollbar {
    display: block !important;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.primary} #e3e3e3;
  }

  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 12px;
  }

  *::-webkit-scrollbar-track {
    background: #e3e3e3;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.primary};
    border-radius: 20px;
    border: 3px solid #e3e3e3;
  }
  button {
    all: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    font-weight: 400;
    font-size: 0.875rem;
    color: ${(props) => props.theme['primary-800']};
    cursor: pointer;
  }
`;

export const ContentItemsFilterColumnTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .editorDescription {
    margin: 0;
    color: ${(props) => props.theme['gray-400']};
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

  .editorSectionHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    color: ${(props) => props.theme['gray-500']};
    font-size: 0.875rem;
    font-weight: 500;

    span:last-child {
      color: ${(props) => props.theme['gray-300']};
      font-size: 0.75rem;
      font-weight: 400;
      white-space: nowrap;
    }
  }

  .columnGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;

    label {
      display: flex;
      align-items: center;
      gap: 0.625rem;
      min-height: 2.75rem;
      margin: 0;
      padding: 0.75rem;
      border: 1px solid ${(props) => props.theme['gray-100']};
      border-radius: 0.5rem;
      color: ${(props) => props.theme['gray-500']};
      cursor: pointer;
      font-size: 0.875rem;
      font-weight: 400;
      transition: border-color 0.2s ease, background-color 0.2s ease;

      &:hover {
        border-color: ${(props) => props.theme.primary};
        background: ${(props) => props.theme['white-100']};
      }

      input {
        flex-shrink: 0;
        width: 1rem;
        height: 1rem;
        margin: 0;
        accent-color: ${(props) => props.theme.primary};
      }
    }
  }

  @media (max-width: 480px) {
    .editorSectionHeader {
      align-items: flex-start;
      flex-direction: column;
      gap: 0.25rem;
    }

    .columnGrid {
      grid-template-columns: 1fr;
    }
  }

  .recommendText {
    font-weight: 400;
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
    color: #07bd12;
    background: #def7ec;
    width: 100%;
    max-width: 7.5rem;
    border-radius: 29px;
  }

  .addMore {
    font-size: 0.875rem;
    font-weight: 400;
    color: ${(props) => props.theme['gray-300']};
  }

  .contentInput {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    label {
      display: flex;
      gap: 0.5rem;
      font-size: 0.875rem;
      color: ${(props) => props.theme['gray-500']};
      margin: 0;
      font-weight: 400;
    }
  }

  .important {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: ${(props) => props.theme['gray-500']};
    line-height: 100%;
  }

  .warning {
    font-weight: 400;
    font-size: 0.75rem;
    color: ${(props) => props.theme['white-800']};
    padding: 0.75rem;
    border: 1px solid ${(props) => props.theme['white-800']};
    border-radius: 12px;
    margin: 0;
  }
`;
